export function getCalculatedParams(): Record<string, string> {
  const now = new Date();

  return {
    pd: now.getDate().toString(),
    pw: now.getDay().toString(),
    pv: now.getHours().toString(),
    prr: typeof document !== 'undefined' && document.referrer ? encodeURIComponent(document.referrer) : '',
    dl: location.href,
  };
}
